import {
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { AlertSchema } from '../../../requests/api/apiTypes';

interface ISoilMoistureAlertLimit {
  open: boolean
  sectorId: string
  alertData: AlertSchema | undefined
  limits: Array<{
    name: string;
    customLabel?: string;
    value: number;
    top: boolean;
  }>;
  activeSoilAlerts: {
    [label: string]: boolean;
  }
  setActiveSoilAlerts: React.Dispatch<React.SetStateAction<{
    [label: string]: boolean;
  }>>
}

const SoilMoistureAlertLimit: React.FC<ISoilMoistureAlertLimit> = ({
  open,
  sectorId,
  alertData,
  limits,
  activeSoilAlerts,
  setActiveSoilAlerts,
}) => {
  const [alertLimits, setAlertLimits] = useState<Array<{
    name: string;
    customLabel?: string;
    value: number;
    top: boolean;
  }>>(limits || []);

  useEffect(() => {
    setAlertLimits(limits);
  }, [limits]);

  useEffect(() => {
    const initial: { [name: string]: boolean } = {};
    if (!alertData) {
      // Initialize with default values (all true)

      alertLimits.forEach((line: any) => {
        if (line.name) {
          initial[line.name] = true;
        }
      });

      setActiveSoilAlerts(initial);
    } else {
      setAlertLimits(alertData.limits);
      setActiveSoilAlerts(alertData.limits.reduce(
        (acc: { [name: string]: boolean }, limit: any) => {
          acc[limit.name] = true;
          return acc;
        }, {},
      ));
    }
  }, [sectorId, open, alertData]);

  const getLimitType = (name: string) => {
    if (name === 'maxValue') return 'Superior';
    if (name === 'minValue') return 'Inferior';
    return 'Crítico';
  };

  return (
    <TableContainer component={Paper} sx={{ mb: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Etiqueta</TableCell>
            <TableCell>Valor</TableCell>
            <TableCell>Tipo de límite</TableCell>
            <TableCell>Activar alerta</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alertLimits.map((line, idx) => (
            <TableRow key={idx}>
              <TableCell>{line.customLabel || line.name}</TableCell>
              <TableCell>{line.value}</TableCell>
              <TableCell>{getLimitType(line.name)}</TableCell>
              <TableCell>
                <Switch
                  checked={!!activeSoilAlerts[line.name]}
                  onChange={() => setActiveSoilAlerts((prev) => ({
                    ...prev,
                    [line.name]: !prev[line.name],
                  }))}
                  color="primary"
                  disabled={!!alertData}
                  sx={{
                    '& .MuiSwitch-switchBase': {
                      color: '#a8d4f7',
                      '&.Mui-checked': {
                        color: '#3693d5',
                      },
                      '&.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#3693d5',
                      },
                    },
                    '& .MuiSwitch-track': {
                      backgroundColor: '#a8d4f7',
                    },
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SoilMoistureAlertLimit;
